export type SprintsState = {
	selected: string[];
};

export const initialSprintsState: SprintsState = { selected: [] };
